import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

function SelectComp({
    value,
    data = [],
    label,
    handleChange,
    name,
    ...props
}) {
    return (
        <FormControl sx={{ minWidth: '100px' }} {...props}>
            <InputLabel id="demo-simple-select-label">{label}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                label={label}
                onChange={handleChange}
                name={name}
                {...props}
            >
                {data.map(el => <MenuItem key={el} value={el}>{el}</MenuItem>)}
            </Select>
        </FormControl>
    )
}

SelectComp.propTypes = {
    value: PropTypes.any.isRequired, // Change 'any' to the appropriate type if known
    data: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired, // Change 'any' to the appropriate type if known
            label: PropTypes.string.isRequired
        })
    ).isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired
}

export default SelectComp
